import { createAsyncAction, createStandardAction } from 'typesafe-actions';

import generateLogger from '@travel/logger';

import { setCommonError } from 'store/commonError/actions';

import { getCouponListAPI, postCouponAPI } from './api';

import type { AppThunk } from 'typesafe-actions';
import type { CouponSearchRequestBody } from 'RakutenMobile-Types';
export const fetchMobileCouponListAsync = createAsyncAction(
  'FETCH_RAKUTEN_MOBILE_REQUEST',
  'FETCH_RAKUTEN_MOBILE_COUPON_SUCCESS',
  'FETCH_RAKUTEN_MOBILE_COUPON_FAILURE',
)<undefined, any, any>();

export const submitMobileCouponAsync = createAsyncAction(
  'SUBMIT_RAKUTEN_MOBILE_COUPON_REQUEST',
  'SUBMIT_RAKUTEN_MOBILE_COUPON_SUCCESS',
  'SUBMIT_RAKUTEN_MOBILE_COUPON_FAILURE',
)<undefined, any, any>();

export const closeCouponSelection = createStandardAction('CLOSE_COUPON_SELECTION_DIALOG')();
export const closeFailSubmitCouponDialog = createStandardAction(
  'CLOSE_FAIL_SUBMIT_COUPON_DIALOG',
)();
const logger = generateLogger();

export const fetchCouponList =
  (params: CouponSearchRequestBody): AppThunk =>
  async (dispatch, _getState) => {
    dispatch(fetchMobileCouponListAsync.request());

    try {
      const response = await getCouponListAPI(params);
      if (!response.ok) {
        const error = await response.json();
        logger.error('error', error);
        dispatch(fetchMobileCouponListAsync.failure(error));
        dispatch(
          setCommonError({ message: 'test error message', httpStatusCode: response.status }),
        );
      }
      const { results, errors } = await response.json();
      if (errors) {
        logger.error(errors);
        dispatch(
          fetchMobileCouponListAsync.failure({ ...errors, reservationId: params.reservationId }),
        );
      } else {
        dispatch(fetchMobileCouponListAsync.success(results));
      }
    } catch (error) {
      logger.error(error);
      dispatch(fetchMobileCouponListAsync.failure(error));
    }
  };

export const submitCoupon =
  (params: { couponCode: string; discountedPrice: number }): AppThunk =>
  async (dispatch, getState) => {
    dispatch(submitMobileCouponAsync.request());
    const state = getState();
    const reservationId = state.rakutenMobile.couponList.reservationId;
    const requestBody = { ...params, reservationId };

    try {
      const response = await postCouponAPI(requestBody);
      if (!response.ok) {
        const error = await response.json();
        logger.error(error);
        dispatch(submitMobileCouponAsync.failure(error));
      }
      const { errors, results } = await response.json();
      if (errors) {
        logger.error(errors);
        dispatch(submitMobileCouponAsync.failure(errors));
      } else {
        dispatch(submitMobileCouponAsync.success(results));
      }
    } catch (error) {
      logger.error(error);
      dispatch(submitMobileCouponAsync.failure(error));
    }
  };
